import s from './ButtonLinkMore.module.sass'

import { FC } from 'react'
import Link from '@shared/ui/Navigation/Link'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { Button } from '@shared/ui/Actions/Button'
import { EGG } from '@shared/api/analytics'
import { PickAnalytic } from '@shared/api/analytics/types/types'

import SliderArrow from '@icons/icon-arrow-slider.svg'

type LinkObject = { pathname?: string; href?: string }

interface Props {
  link: string | LinkObject
  handleBeforeAction?: () => boolean
  text?: string
  disabled?: boolean
  className?: string
  analytic?: PickAnalytic<null, 'section_name'>
}

const ButtonLinkMore: FC<Props & React.ButtonHTMLAttributes<any>> = (props) => {
  const { text = 'Все', className = '', disabled = false, link, handleBeforeAction, analytic, ...rest } = props

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    analytic && EGG.common.button_all_click(analytic)
    const shouldNavigate = !handleBeforeAction || handleBeforeAction()
    if (!shouldNavigate) {
      event.preventDefault()
    }
  }

  return (
    <BlockBoundary>
      <Link href={link} {...rest} onClick={handleClick} scroll={false}>
        <Button sizes='M S' mode='white-shadow' className={`${s.button} ${className}`} disabled={disabled}>
          {text}
          <SliderArrow className={s.icon} />
        </Button>
      </Link>
    </BlockBoundary>
  )
}

export default ButtonLinkMore
